module.exports = __webpack_public_path__ + "img/code.9f02dd65.png";